
import Promise from 'promise-polyfill';
import { allImagesLoaded } from '../utils/utils.image-loaded';

const 	$ = jQuery;

const 	$imageGallery = $('.js-image-gallery'),
		$stage = $imageGallery.find('.js-stage'),
		$stageImages = $imageGallery.find('.js-stage-image'),
		$thumbnailButton = $imageGallery.find('.js-thumb-button'),
		$image360 = $imageGallery.find('.js-360-image'),
		$spinner = $imageGallery.find('.js-spinner');

function hideAllImages() {
	$stageImages.hide();
}

function retainStageProportions() {
	$stage.height($stage.height());
	$stage.width($stage.width());
}

function stageProportionsAuto() {
	$stage.css({
		'height': 'auto',
		'width': 'auto'
	});
}

function showImage(index) {

	if ( $stageImages.eq(index).is( $image360 ) && !$image360.hasClass('instantiated') ) {
		
		let enforcedDelayDuration = 1000;

		$spinner.fadeIn();

		let enforcedDelay = new Promise( resolve => {
			window.setTimeout( () => {
				resolve();
			}, enforcedDelayDuration);
		});

		Promise.all([enforcedDelay, swapInImageSources()]).then(() => {
			$stageImages.eq(index).css('display', 'block');
			stageProportionsAuto();
			$spinner.fadeOut();
		});
	} else {
		$stageImages.eq(index).css('display', 'block');	
		stageProportionsAuto();
	}
}

function swapInImageSources() {

	let pathsArray = [];

	$image360.find('img').each(function() {
		pathsArray.push( $(this).data('source') );
	});

	return new Promise(resolve => {
		allImagesLoaded(pathsArray).then( (paths) => {
			
			$image360.find('img').each(function() {
				const dataSource = $(this).data('source');
				$(this).attr('src', dataSource);
			});

			$image360.addClass('instantiated');

			resolve();
		});
	});
}

function init() {

	$thumbnailButton.on('click', (e) => {
		
		const 	$clickedElem = $(e.currentTarget),
				clickedIndex = $clickedElem.data('index');
		
		$thumbnailButton.removeClass('is-current');
		$clickedElem.addClass('is-current');
		retainStageProportions()
		hideAllImages();
		showImage(clickedIndex - 1); 
	});

	$thumbnailButton.eq(0).addClass('is-current');
}

if ( $imageGallery.length && $stageImages.length ) {
	init();
}
